module.exports = __webpack_public_path__ + "img/sold_out.48f7ddc7.png";